import { EnvConfig } from '@/config/env';
import { getWsoOauth, getKerberosConfig } from '@/config/oauth';
import { IAuthService } from './IAuthService';
import KerberosAuthService from './KerberosAuthService';
import Wso2AuthService from './Wso2AuthService';

export function createAuthService(config: EnvConfig): IAuthService {
    if (config.WSO?.AUTH_TYPE === 'kerberos') {
        return new KerberosAuthService(getKerberosConfig(config));
    }
    return new Wso2AuthService(getWsoOauth(config));
}

export default createAuthService;
